var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSummary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.5H0.5V18.5H18.5V6.5L12.5 0.5ZM5.5 14.5C4.95 14.5 4.5 14.05 4.5 13.5C4.5 12.95 4.95 12.5 5.5 12.5C6.05 12.5 6.5 12.95 6.5 13.5C6.5 14.05 6.05 14.5 5.5 14.5ZM5.5 10.5C4.95 10.5 4.5 10.05 4.5 9.5C4.5 8.95 4.95 8.5 5.5 8.5C6.05 8.5 6.5 8.95 6.5 9.5C6.5 10.05 6.05 10.5 5.5 10.5ZM5.5 6.5C4.95 6.5 4.5 6.05 4.5 5.5C4.5 4.95 4.95 4.5 5.5 4.5C6.05 4.5 6.5 4.95 6.5 5.5C6.5 6.05 6.05 6.5 5.5 6.5ZM11.5 7.5V2L17 7.5H11.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummary);
export default __webpack_public_path__ + "static/media/summary.4a827306487bacb6ce529ad7cf868a89.svg";
export { ForwardRef as ReactComponent };